import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import moment from 'moment'
import disposal from '../../redux/actions/disposal'
import setuju from '../../redux/actions/setuju'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const { REACT_APP_BACKEND_URL } = process.env

// ── Helpers ───────────────────────────────────────────────────────────────────

const toBase64 = (url, headers = {}) =>
  fetch(url, { headers })
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror  = reject;
          reader.readAsDataURL(blob);
        })
    );

const formatName = (nama) => {
  if (!nama) return null
  if (nama.length <= 15) {
    return nama.split(' ').map((w) => (w ? w[0].toUpperCase() + w.slice(1) : '')).join(' ')
  }
  return (
    nama.slice(0, 13).split(' ').map((w) => (w ? w[0].toUpperCase() + w.slice(1) : '')).join(' ') + '.'
  )
}

const toRupiah = (num) =>
  (parseInt(num) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

const buildApprovalHeader = (label, colSpan = 1) => ({
  text:      label,
  bold:      true,
  alignment: 'center',
  fontSize:  7,
  border:    [true, true, true, true],
  fillColor: '#f2f2f2',
  margin:    [2, 3, 2, 3],
  colSpan,
})

const buildApprovalBody = (item) => {
  const border = [true, true, true, true]

  if (!item) {
    return {
      stack:  [{ text: '\n\n-\n\n-', alignment: 'center', fontSize: 7 }],
      border,
      margin: [2, 4, 2, 4],
    }
  }

  const name    = formatName(item.nama)
  const date    = moment(item.updatedAt).format('DD/MM/YYYY')
  const status  = item.status === 0 ? `Reject (${date})` : item.status === 1 ? `Approve (${date})` : '-'
  const jabatan = item.jabatan ? item.jabatan.toUpperCase() : '-'

  return {
    stack: [
      { text: status,      alignment: 'center', fontSize: 6, margin: [0, 4, 0, 0] },
      { text: '\n' },
      { text: name || '-', alignment: 'center', fontSize: 7 },
      { text: jabatan,     alignment: 'center', fontSize: 6 },
    ],
    border,
    margin: [2, 4, 2, 4],
  }
}

// ─────────────────────────────────────────────────────────────────────────────

class FormDisposal extends Component {

  prosesDownload = async () => {
    const token = localStorage.getItem('token')
    const { detailDis } = this.props.disposal
    await this.props.getNewDetailDisposal(token, detailDis[0].no_disposal)
    await this.props.getApproveDisposal(token, detailDis[0].no_disposal, 'Disposal')
    this.downloadForm()
  }

  downloadForm = async () => {
    // ── Ambil data dari props (sama persis seperti versi Excel) ──────────────
    const { disApp, detailNew, infoApp } = this.props.disposal

    // ── Parse matrix otorisasi (sama persis seperti versi Excel) ─────────────
    const splitApp     = infoApp.info ? infoApp.info.split(']') : []
    const pembuatApp   = splitApp.length > 0 ? splitApp[0] : ''
    const pemeriksaApp = splitApp.length > 0 ? splitApp[1] : ''
    const penyetujuApp = splitApp.length > 0 ? splitApp[2] : ''

    const areaAppIt = `${pembuatApp.split(';')[4] && pembuatApp.split(';')[4]}, ${pemeriksaApp.split(';')[4] && pemeriksaApp.split(';')[4]}, ${penyetujuApp.split(';')[4] && penyetujuApp.split(';')[4]}`
    const areaApp   = `${pembuatApp.split(';')[3] && pembuatApp.split(';')[3]}, ${pemeriksaApp.split(';')[3] && pemeriksaApp.split(';')[3]}, ${penyetujuApp.split(';')[3] && penyetujuApp.split(';')[3]}`
    const hoAppIt   = `${pembuatApp.split(';')[2] && pembuatApp.split(';')[2]}, ${pemeriksaApp.split(';')[2] && pemeriksaApp.split(';')[2]}, ${penyetujuApp.split(';')[2] && penyetujuApp.split(';')[2]}`
    const hoApp     = `${pembuatApp.split(';')[1] && pembuatApp.split(';')[1]}, ${pemeriksaApp.split(';')[1] && pemeriksaApp.split(';')[1]}, ${penyetujuApp.split(';')[1] && penyetujuApp.split(';')[1]}`

    // ── Logo ─────────────────────────────────────────────────────────────────
    let logoBase64 = null
    try {
      const token = localStorage.getItem('token')

      logoBase64 = await toBase64(
        `${REACT_APP_BACKEND_URL}/masters/logo.png`,
        { Authorization: `Bearer ${token}` }
      )
    } catch (e) {
      console.warn('Logo gagal dimuat:', e)
    }

    // ── Approval lists (filter hidden sama seperti versi Excel) ───────────────
    const buatList    = disApp?.pembuat   ? [...disApp.pembuat]   : []
    const periksaList = disApp?.pemeriksa ? disApp.pemeriksa.filter((x) => x.status_view !== 'hidden') : []
    const setujuList  = disApp?.penyetuju ? [...disApp.penyetuju] : []

    if (!buatList.length)    buatList.push(null)
    if (!periksaList.length) periksaList.push(null)
    if (!setujuList.length)  setujuList.push(null)

    const totalCols      = buatList.length + periksaList.length + setujuList.length
    const approvalWidths = Array(totalCols).fill('*')

    // Row 1: group header dengan colSpan
    const approvalHeaderRow = [
      { ...buildApprovalHeader('Dibuat oleh,', buatList.length) },
      ...Array(buatList.length - 1).fill({ text: '', border: [false, false, false, false] }),
      { ...buildApprovalHeader('Diperiksa oleh,', periksaList.length) },
      ...Array(periksaList.length - 1).fill({ text: '', border: [false, false, false, false] }),
      { ...buildApprovalHeader('Disetujui oleh,', setujuList.length) },
      ...Array(setujuList.length - 1).fill({ text: '', border: [false, false, false, false] }),
    ]

    // Row 2: isi nama, status, jabatan per orang
    const approvalBodyRow = [
      ...buatList.map((item)    => buildApprovalBody(item)),
      ...periksaList.map((item) => buildApprovalBody(item)),
      ...setujuList.map((item)  => buildApprovalBody(item)),
    ]

    // ── Info surat ────────────────────────────────────────────────────────────
    const firstDetail = detailNew?.[0]
    const area        = firstDetail !== undefined ? firstDetail.area       : ''
    const tglDis      = firstDetail !== undefined ? firstDetail.tanggalDis : new Date()
    const dateStr     = `${area}, ${moment(tglDis).locale('id').format('DD MMMM YYYY')}`
    const cabangDepo  = firstDetail !== undefined
      ? `${firstDetail.area} - ${firstDetail.cost_center}`
      : '-'

    // ── Tabel aset ────────────────────────────────────────────────────────────
    const itemHeader = [
      'No.', 'Nomor Asset', 'Nama Barang', 'Merk / Type',
      'Kategori\nIT / Non IT', 'Cabang / Depo', 'Cost Center',
      'Nilai Buku', 'Nilai Jual', 'Keterangan',
    ].map((h) => ({
      text:      h,
      bold:      true,
      alignment: 'center',
      fillColor: '#f2f2f2',
      border:    [true, true, true, true],
      fontSize:  7,
    }))

    const itemRows = (detailNew || []).map((item, index) => [
      { text: String(index + 1),                                    alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.no_asset}`,                                   alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.nama_asset}`,                                 alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: item.merk === null ? '-' : `${item.merk}`,           alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.kategori}`,                                   alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.area}`,                                       alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.cost_center}`,                                alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: toRupiah(item.nilai_buku  ?? 0),                      alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: toRupiah(item.nilai_jual  ?? 0),                      alignment: 'center', border: [true,true,true,true], fontSize: 7 },
      { text: `${item.keterangan}`,                                 alignment: 'center', border: [true,true,true,true], fontSize: 7 },
    ])

    // Baris total nilai buku & nilai jual
    const totalNilaiBuku = (detailNew || []).reduce((sum, item) => sum + (parseInt(item.nilai_buku) || 0), 0)
    const totalNilaiJual = (detailNew || []).reduce((sum, item) => sum + (parseInt(item.nilai_jual) || 0), 0)

    const totalRow = [
      { text: 'Total', bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 7, colSpan: 7, fillColor: '#f2f2f2' },
      { text: '', border: [false,false,false,false], fontSize: 7 },
      { text: '', border: [false,false,false,false], fontSize: 7 },
      { text: '', border: [false,false,false,false], fontSize: 7 },
      { text: '', border: [false,false,false,false], fontSize: 7 },
      { text: '', border: [false,false,false,false], fontSize: 7 },
      { text: '', border: [false,false,false,false], fontSize: 7 },
      { text: toRupiah(totalNilaiBuku), bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 7, fillColor: '#f2f2f2' },
      { text: toRupiah(totalNilaiJual), bold: true, alignment: 'center', border: [true,true,true,true], fontSize: 7, fillColor: '#f2f2f2' },
      { text: '', border: [true,true,true,true], fontSize: 7 },
    ]

    // ── Doc definition ────────────────────────────────────────────────────────
    const docDefinition = {
      pageSize:        'A4',
      pageOrientation: 'landscape',
      pageMargins:     [25, 25, 25, 30],

      footer: (currentPage, pageCount) => ({
        text:      `Halaman ${currentPage} dari ${pageCount}`,
        alignment: 'center',
        fontSize:  7,
        margin:    [0, 8, 0, 0],
      }),

      content: [

        // ── Header: Logo + Nama Perusahaan + Judul ────────────────────────────
        {
          columns: [
            {
              stack: [
                logoBase64
                  ? { image: logoBase64, width: 40, height: 50, margin: [0, 0, 0, 2] }
                  : { text: '' },
                { text: 'PT. Pinus Merah Abadi', bold: true, fontSize: 10, margin: [0, 4, 0, 0] },
              ],
              width: 170,
            },
            {
              text:      'FORM PENGAJUAN DISPOSAL ASET',
              style:     'title',
              alignment: 'center',
              margin:    [0, 16, 0, 0],
            },
            { text: '', width: 170 }, // spacer agar judul benar-benar center
          ],
          margin: [0, 0, 0, 10],
        },

        // ── Info surat ────────────────────────────────────────────────────────
        { text: dateStr, fontSize: 8, margin: [0, 0, 0, 4] },
        {
          columns: [
            { text: 'Hal',                width: 100, fontSize: 8 },
            { text: ': Pengajuan Disposal Asset',     fontSize: 8 },
          ],
          margin: [0, 0, 0, 2],
        },
        {
          columns: [
            { text: 'Cabang / Depo / HO', width: 100, fontSize: 8 },
            { text: `: ${cabangDepo}`,                fontSize: 8 },
          ],
          margin: [0, 0, 0, 8],
        },
        { text: 'Kepada Yth.',        fontSize: 8 },
        { text: 'Bpk/Ibu Pimpinan',  fontSize: 8 },
        { text: 'Di tempat',          fontSize: 8, margin: [0, 0, 0, 6] },
        { text: 'Dengan Hormat,',     fontSize: 8 },
        {
          text:   'Dengan surat ini kami mengajukan permohonan disposal aset dengan perincian sbb :',
          fontSize: 8,
          margin:   [0, 0, 0, 8],
        },

        // ── Tabel Detail Aset ─────────────────────────────────────────────────
        {
          table: {
            headerRows: 1,
            widths:     ['auto', 55, '*', 50, 40, 55, 38, 52, 52, '*'],
            body:       [itemHeader, ...itemRows, totalRow],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Penutup ───────────────────────────────────────────────────────────
        {
          text:   'Demikian hal yang kami sampaikan, atas perhatiannya kami mengucapkan terima kasih',
          fontSize: 8,
          margin:   [0, 0, 0, 10],
        },

        // ── Tabel Approval ────────────────────────────────────────────────────
        {
          table: {
            widths: approvalWidths,
            body:   [approvalHeaderRow, approvalBodyRow],
          },
          layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          margin: [0, 0, 0, 10],
        },

        // ── Matrix Otorisasi ──────────────────────────────────────────────────
        {
          text:       'Matrix Otorisasi ditandatangani oleh:',
          bold:       true,
          decoration: 'underline',
          fontSize:   8,
          margin:     [0, 0, 0, 4],
        },
        {
          columns: [
            {
              stack: [
                { text: 'Aset (Nilai ≥ Rp 1.000.000, Barang IT)',  bold: true, fontSize: 7 },
                { text: `1. Area : ${areaAppIt}`,                              fontSize: 7, margin: [0, 2, 0, 0] },
                { text: `2. Head Office : ${hoAppIt}`,                         fontSize: 7, margin: [0, 2, 0, 0] },
              ],
            },
            {
              stack: [
                { text: 'Aset (Nilai ≥ Rp 1.000.000, Barang Non IT)', bold: true, fontSize: 7 },
                { text: `1. Area : ${areaApp}`,                                   fontSize: 7, margin: [0, 2, 0, 0] },
                { text: `2. Head Office : ${hoApp}`,                              fontSize: 7, margin: [0, 2, 0, 0] },
              ],
            },
          ],
          margin: [0, 0, 0, 8],
        },

        // ── Nomor Form ────────────────────────────────────────────────────────
        { text: 'FRM-HCD-105(1) REV 10', fontSize: 7 },
      ],

      styles: {
        title: {
          bold:       true,
          fontSize:   13,
          decoration: 'underline',
        },
      },

      defaultStyle: {
        fontSize: 8,
        font:     'Roboto',
      },
    }

    const fileName = `Form Disposal Asset ${firstDetail?.no_disposal ?? ''} ${moment().format('DD MMMM YYYY')}.pdf`

    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).download(fileName, () => resolve(fileName))
      } catch (err) {
        reject(err)
      }
    })
  }

  render() {
    return (
      <Button className='ml-2' color="info" onClick={this.prosesDownload}>
        Download Form Pengajuan PDF
      </Button>
    )
  }
}

const mapStateToProps = (state) => ({
  asset:    state.asset,
  depo:     state.depo,
  mutasi:   state.mutasi,
  disposal: state.disposal,
  setuju:   state.setuju,
  user:     state.user,
  tempmail: state.tempmail,
  newnotif: state.newnotif,
  dokumen:  state.dokumen,
})

const mapDispatchToProps = {
  getApproveDisposal:    disposal.getApproveDisposal,
  getNewDetailDisposal:  disposal.getNewDetailDisposal,
  getApproveSetDisposal: setuju.getApproveSetDisposal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormDisposal)